/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useState } from 'react';
import { Box, Grid, List, ListItem, ListItemText, Modal } from '@mui/material';
import useStyles from '../../../assets/styles/components/Modals';
import { ReactComponent as IconRight } from '../../../assets/images/svg/shops/request/Vector.svg';

const styleModal = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 680,
  borderRadius: 4,
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  height: '410px',
};

type Props = {
  isOpen: boolean;
  title: string;
  dataList: [];
  handleFn: (item?: any) => Promise<void>;
  useIconRight?: boolean;
  onClose: () => void;
};

const ModalListCenter = ({
  isOpen,
  title,
  dataList,
  handleFn,
  useIconRight = false,
  onClose,
}: Props): ReactElement => {
  const classeStyle = useStyles();

  const [openModal, setOpenModal] = useState(isOpen);

  const closeModal = (): void => {
    setOpenModal(!openModal);
    onClose();
  };

  useEffect(() => {
    setOpenModal(isOpen);
  }, [isOpen]);
  return (
    <Modal
      style={{ margin: '0px 20px' }}
      open={openModal}
      onClose={closeModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styleModal}>
        <Grid
          container
          item
          xs={12}
          justifyContent="center"
          className={classeStyle.gridModalTop}
        >
          <h4 style={{ margin: '8px' }}>{title}</h4>
        </Grid>
        {dataList?.length > 0 && (
          <Grid padding="0px 15px">
            <Box
              sx={{
                width: '100%',
                height: 350,
              }}
            >
              <List
                sx={{
                  width: '100%',
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 350,
                  '& ul': { padding: 0 },
                }}
                subheader={<li />}
              >
                {dataList.map((item: any, index: number) => (
                  <li
                    key={`${
                      item.idRestaurante ||
                      item.idPagamento ||
                      item.idGanhador ||
                      item.idPedido
                    }`}
                  >
                    <ul>
                      <ListItem
                        onClick={() => handleFn(item)}
                        className={classeStyle.gridNameModal}
                      >
                        <ListItemText
                          className={classeStyle.nameModal}
                          primary={
                            item.dsNome || item.dsPagamento
                              ? `${item.dsNome || item.dsPagamento}`
                              : item.dsPremio
                              ? `${index + 1}) ${item.dsPremio}`
                              : `#${item.idPedido} - ${item.dtPedido}`
                          }
                        />
                        {useIconRight && <IconRight width={15} height={15} />}
                      </ListItem>
                    </ul>
                  </li>
                ))}
              </List>
            </Box>
          </Grid>
        )}
      </Box>
    </Modal>
  );
};

export default ModalListCenter;
